// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"4edab05a","453":"c862571e"}[chunkId] + ".chunk.js";
};